import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { DecimalPipe as NgDecimalPipe } from '@angular/common'
import { invalidPipeArgumentError } from './invalid-pipe-argument-error'
import { merge } from 'lodash';


@Pipe({ name: 'decimal' })
export class DecimalPipe implements PipeTransform {
  private pipe

  constructor(@Inject(LOCALE_ID) locale: string) {
    this.pipe = new NgDecimalPipe(locale)
  }

  transform(value: number, options = {}): string {
    let decimalPlaces: number

    if (isNaN(value)) {
      throw invalidPipeArgumentError('decimal', value)
    }

    if (value == null) {
      return 'n/a'
    }

    if (!isNaN(options['decimal_places'])) {
      decimalPlaces = options['decimal_places']
    } else {
      decimalPlaces = 2
    }

    const opts = merge({
      digits: `1.${decimalPlaces}-${decimalPlaces}`
    }, options)

    return this.pipe.transform(value, opts['digits'])
  }
}
